import { createRouter, createWebHashHistory } from 'vue-router'
import home from '../views/Main.vue'

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/login.vue'),
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/404/404.vue'),
  },
  {
    path: '/',
    name: 'home',
    component: home,
    children: [
      {
        path: '/Main',
        name: 'Main',
        component: () =>
        import(
          /* webpackChunkName: "403" */
          '../views/Homepage.vue'
        ),
      },
      {
        path: '/selectiveexperiment',
        name: 'selectiveexperiment',
        component: () => import('../views/SelectiveExperiment.vue'),
      },
      {
        path: '/Previewtopic',
        name: 'Previewtopic',
        component: () => import('../views/PreviewsTopic.vue'),
      },
      {
        path: '/ProjectManagement',
        name: 'ProjectManagement',
        meta: {
          requireAuth: true,
          title: '项目管理',
        },
        component: () =>
          import(
            /* webpackChunkName: "403" */
            '../views/ProjectManagement/ProjectManagement.vue'
          ),
      },
      {
        path: '/MiceMarketing',
        name: 'MiceMarketing',
        // meta: {
        //   requireAuth: true,
        //   title: '会展营销',
        // },
        component: () =>
          import(
            /* webpackChunkName: "403" */
            '../views/MiceMarketing/MiceMarketing.vue'
          ),
      },
      {
        path: '/DataAnalysis',
        name: 'DataAnalysis',
        // meta: {
        //   requireAuth: true,
        //   title: '数据分析',
        // },
        component: () =>
          import(
            /* webpackChunkName: "403" */
            '../views/DataAnalysis/DataAnalysis.vue'
          ),
      },
      {
        path: '/ExhibitionServices',
        name: 'ExhibitionServices',
        // meta: {
        //   requireAuth: true,
        //   title: '会展服务',
        // },
        component: () =>
          import(
            /* webpackChunkName: "403" */
            '../views/ExhibitionServices/ExhibitionServices.vue'
          ),
      },
      {
        path: '/FinancialManagement',
        name: 'FinancialManagement',
        // meta: {
        //   requireAuth: true,
        //   title: '财务管理',
        // },
        component: () =>
          import(
            /* webpackChunkName: "403" */
            '../views/FinancialManagement/FinancialManagement.vue'
          ),
      },
      {
        path: '/TeamManagement',
        name: 'TeamManagement',
        // meta: {
        //   requireAuth: true,
        //   title: '团队管理',
        // },
        component: () =>
          import(
            /* webpackChunkName: "403" */
            '../views/TeamManagement/TeamManagement.vue'
          ),
      },
      {
        path: '/AchievementsCard',
        name: 'AchievementsCard',
        meta: {
          requireAuth: true,
          title: '成就管理',
        },
        component: () =>
          import(
            '../views/Card/Head/AchievementsCard.vue'
          ),
      },
      {
        path: '/ScoringRules',
        name: 'ScoringRules',
        meta: {
          requireAuth: true,
          title: '评分规则',
        },
        component: () =>
          import(
            '../views/Card/Head/ScoringRules.vue'
          ),
      },
      {
        path: '/MyCollect',
        name: 'MyCollect',
        meta: {
          requireAuth: true,
          title: '我的收藏',
        },
        component: () =>
          import(
            '../views/Card/Head/MyCollect.vue'
          ),
      },
      {
        path: '/KnowledgeControl',
        name: 'KnowledgeControl',
        meta: {
          requireAuth: true,
          title: '知识点',
        },
        component: () =>
          import(
            '../views/UserControl/KnowledgeControl.vue'
          ),
      },
      {
        path: '/ExhibitionPlanningNewCard',
        name: 'ExhibitionPlanningNewCard',
        meta: {
          requireAuth: true,
          title: '会展策划',
        },
        component: () =>
          import(
            '../views/Card/ProjectManagementCard/ExhibitionPlanningNewCard.vue'
          ),
      },
      {
        path: '/BudgetCustomizedCard',
        name: 'BudgetCustomizedCard',
        meta: {
          requireAuth: true,
          title: '预算定制',
        },
        component: () =>
          import(
            '../views/Card/ProjectManagementCard/BudgetCustomizedCard.vue'
          ),
      },
      {
        path: '/PriceCustomizedCard',
        name: 'PriceCustomizedCard',
        meta: {
          requireAuth: true,
          title: '价格制定',
        },
        component: () =>
          import(
            '../views/Card/ProjectManagementCard/PriceCustomizedCard.vue'
          ),
      },
      {
        path: '/ReportExportCard',
        name: 'ReportExportCard',
        meta: {
          requireAuth: true,
          title: '实验报告',
        },
        component: () =>
          import(
            '../views/Card/ProjectManagementCard/ReportExportCard.vue'
          ),
      },
      {
        path: '/ReportExportDetailCard',
        name: 'ReportExportDetailCard',
        meta: {
          requireAuth: true,
          title: '实验报告详情',
        },
        component: () =>
          import(
            '../views/Card/ProjectManagementCard/ReportExportDetailCard.vue'
          ),
      },
      {
        path: '/InformationCard',
        name: 'InformationCard',
        meta: {
          requireAuth: true,
          title: '信息发布',
        },
        component: () =>
          import(
            '../views/Card/MiceMarketing/InformationCard.vue'
          ),
      },
      {
        path: '/MediaInvitationsCard',
        name: 'MediaInvitationsCard',
        meta: {
          requireAuth: true,
          title: '媒体邀约',
        },
        component: () =>
          import(
            '../views/Card/MiceMarketing/MediaInvitationsCard.vue'
          ),
      },
      {
        path: '/MediaDeatilCard',
        name: 'MediaDeatilCard',
        meta: {
          requireAuth: true,
          title: '媒体邀约详情',
        },
        component: () =>
          import(
            '../views/Card/MiceMarketing/MediaDeatilCard.vue'
          ),
      },
      {
        path: '/ThemeAttractInvestmentCard',
        name: 'ThemeAttractInvestmentCard',
        meta: {
          requireAuth: true,
          title: '主题招商演讲',
        },
        component: () =>
          import(
            '../views/Card/MiceMarketing/ThemeAttractInvestmentCard.vue'
          ),
      },
      {
        path: '/BoothAttractInvestmentCard',
        name: 'BoothAttractInvestmentCard',
        meta: {
          requireAuth: true,
          title: '展位招商',
        },
        component: () =>
          import(
            '../views/Card/MiceMarketing/BoothAttractInvestmentCard.vue'
          ),
      },
      {
        path: '/AdvertAttractInvestmentCard',
        name: 'AdvertAttractInvestmentCard',
        meta: {
          requireAuth: true,
          title: '广告招商',
        },
        component: () =>
          import(
            '../views/Card/MiceMarketing/AdvertAttractInvestmentCard.vue'
          ),
      },
      {
        path: '/TrackAndMarketingCard',
        name: 'TrackAndMarketingCard',
        meta: {
          requireAuth: true,
          title: '现场跟踪及营销',
        },
        component: () =>
          import(
            '../views/Card/MiceMarketing/TrackAndMarketingCard.vue'
          ),
      },
      {
        path: '/NewsCoverageCard',
        name: 'NewsCoverageCard',
        meta: {
          requireAuth: true,
          title: '展后新闻报道',
        },
        component: () =>
          import(
            '../views/Card/MiceMarketing/NewsCoverageCard.vue'
          ),
      },
      {
        path: '/NewsCoverageEditCard',
        name: 'NewsCoverageEditCard',
        meta: {
          requireAuth: true,
          title: '展后新闻报道详情',
        },
        component: () =>
          import(
            '../views/Card/MiceMarketing/NewsCoverageEditCard.vue'
          ),
      },
      {
        path: '/MarketingSummarizeCard',
        name: 'MarketingSummarizeCard',
        meta: {
          requireAuth: true,
          title: '会展营销总结',
        },
        component: () =>
          import(
            '../views/Card/MiceMarketing/MarketingSummarizeCard.vue'
          ),
      },
      {
        path: '/MarketReportCard',
        name: 'MarketReportCard',
        meta: {
          requireAuth: true,
          title: '市场调研分析',
        },
        component: () =>
          import(
            '../views/Card/DataAnalysisCard/MarketReportCard.vue'
          ),
      },
      {
        path: '/PlaceOfOriginCard',
        name: 'PlaceOfOriginCard',
        meta: {
          requireAuth: true,
          title: '举办地区数据分析',
        },
        component: () =>
          import(
            '../views/Card/DataAnalysisCard/PlaceOfOriginCard.vue'
          ),
      },
      {
        path: '/PlaceOfOriginDetailCard',
        name: 'PlaceOfOriginDetailCard',
        meta: {
          requireAuth: true,
          title: '举办地区数据分析详情',
        },
        component: () =>
          import(
            '../views/Card/DataAnalysisCard/PlaceOfOriginDetailCard.vue'
          ),
      },
      {
        path: '/ProcessDataCard',
        name: 'ProcessDataCard',
        meta: {
          requireAuth: true,
          title: '过程数据分析',
        },
        component: () =>
          import(
            '../views/Card/DataAnalysisCard/ProcessDataCard.vue'
          ),
      },
      {
        path: '/FeedbackDataCard',
        name: 'FeedbackDataCard',
        meta: {
          requireAuth: true,
          title: '反馈数据管理',
        },
        component: () =>
          import(
            '../views/Card/DataAnalysisCard/FeedbackDataCard.vue'
          ),
      },
      {
        path: '/MarketingDataManagementCard',
        name: 'MarketingDataManagementCard',
        meta: {
          requireAuth: true,
          title: '营销数据管理',
        },
        component: () =>
          import(
            '../views/Card/DataAnalysisCard/MarketingDataManagementCard.vue'
          ),
      },
      {
        path: '/MarketingDataDetailCard',
        name: 'MarketingDataDetailCard',
        meta: {
          requireAuth: true,
          title: '营销数据管理详情',
        },
        component: () =>
          import(
            '../views/Card/DataAnalysisCard/MarketingDataDetailCard.vue'
          ),
      },
      {
        path: '/SummarizeCard',
        name: 'SummarizeCard',
        meta: {
          requireAuth: true,
          title: '会展数据总结',
        },
        component: () =>
          import(
            '../views/Card/DataAnalysisCard/SummarizeCard.vue'
          ),
      },
      {
        path: '/EventPlanningCard',
        name: 'EventPlanningCard',
        meta: {
          requireAuth: true,
          title: '活动策划',
        },
        component: () =>
          import(
            '../views/Card/ExhibitionServicesCard/EventPlanningCard.vue'
          ),
      },
      {
        path: '/EventPlanningEditCard',
        name: 'EventPlanningEditCard',
        meta: {
          requireAuth: true,
          title: '活动策划详情',
        },
        component: () =>
          import(
            '../views/Card/ExhibitionServicesCard/EventPlanningEditCard.vue'
          ),
      },
      {
        path: '/SiteInquiryCard',
        name: 'SiteInquiryCard',
        meta: {
          requireAuth: true,
          title: '场地询价',
        },
        component: () =>
          import(
            '../views/Card/ExhibitionServicesCard/SiteInquiryCard.vue'
          ),
      },
      {
        path: '/SiteInquiryDetailCard',
        name: 'SiteInquiryDetailCard',
        meta: {
          requireAuth: true,
          title: '场地询价详情',
        },
        component: () =>
          import(
            '../views/Card/ExhibitionServicesCard/SiteInquiryDetailCard.vue'
          ),
      },
      {
        path: '/SignInCard',
        name: 'SignInCard',
        meta: {
          requireAuth: true,
          title: '签到管理',
        },
        component: () =>
          import(
            '../views/Card/ExhibitionServicesCard/SignInCard.vue'
          ),
      },
      {
        path: '/StayArrangeCard',
        name: 'StayArrangeCard',
        meta: {
          requireAuth: true,
          title: '住宿管理',
        },
        component: () =>
          import(
            '../views/Card/ExhibitionServicesCard/StayArrangeCard.vue'
          ),
      },
      {
        path: '/RestaurantArrangeCard',
        name: 'RestaurantArrangeCard',
        meta: {
          requireAuth: true,
          title: '餐饮安排',
        },
        component: () =>
          import(
            '../views/Card/ExhibitionServicesCard/RestaurantArrangeCard.vue'
          ),
      },
      {
        path: '/CarDispatchCard',
        name: 'CarDispatchCard',
        meta: {
          requireAuth: true,
          title: '车辆调度',
        },
        component: () =>
          import(
            '../views/Card/ExhibitionServicesCard/CarDispatchCard.vue'
          ),
      },
      {
        path: '/EmergenciesCard',
        name: 'EmergenciesCard',
        meta: {
          requireAuth: true,
          title: '秩序维护',
        },
        component: () =>
          import(
            '../views/Card/ExhibitionServicesCard/EmergenciesCard.vue'
          ),
      },
      {
        path: '/EmergenciesEditCard',
        name: 'EmergenciesEditCard',
        meta: {
          requireAuth: true,
          title: '秩序维护详情',
        },
        component: () =>
          import(
            '../views/Card/ExhibitionServicesCard/EmergenciesEditCard.vue'
          ),
      },
      {
        path: '/FeedbackSurveyCard',
        name: 'FeedbackSurveyCard',
        meta: {
          requireAuth: true,
          title: '反馈调查',
        },
        component: () =>
          import(
            '../views/Card/ExhibitionServicesCard/FeedbackSurveyCard.vue'
          ),
      },
      {
        path: '/ServiceSummaryCard',
        name: 'ServiceSummaryCard',
        meta: {
          requireAuth: true,
          title: '会展服务总结',
        },
        component: () =>
          import(
            '../views/Card/ExhibitionServicesCard/ServiceSummaryCard.vue'
          ),
      },
      {
        path: '/BudgetReviewCard',
        name: 'BudgetReviewCard',
        meta: {
          requireAuth: true,
          title: '预算审核',
        },
        component: () =>
          import(
            '../views/Card/FinancialManagementCard/BudgetReviewCard.vue'
          ),
      },
      {
        path: '/ExpenditureCard',
        name: 'ExpenditureCard',
        meta: {
          requireAuth: true,
          title: '支出管理',
        },
        component: () =>
          import(
            '../views/Card/FinancialManagementCard/ExpenditureCard.vue'
          ),
      },
      {
        path: '/IncomeCard',
        name: 'IncomeCard',
        meta: {
          requireAuth: true,
          title: '收入管理',
        },
        component: () =>
          import(
            '../views/Card/FinancialManagementCard/IncomeCard.vue'
          ),
      },
      {
        path: '/InvoiceCard',
        name: 'InvoiceCard',
        meta: {
          requireAuth: true,
          title: '发票管理',
        },
        component: () =>
          import(
            '../views/Card/FinancialManagementCard/InvoiceCard.vue'
          ),
      },
      {
        path: '/InvoiceEditCard',
        name: 'InvoiceEditCard',
        meta: {
          requireAuth: true,
          title: '发票管理详情',
        },
        component: () =>
          import(
            '../views/Card/FinancialManagementCard/InvoiceEditCard.vue'
          ),
      },
      {
        path: '/ReportFormsCard',
        name: 'ReportFormsCard',
        meta: {
          requireAuth: true,
          title: '报表管理',
        },
        component: () =>
          import(
            '../views/Card/FinancialManagementCard/ReportFormsCard.vue'
          ),
      },
      {
        path: '/RevenueAnalysisCard',
        name: 'RevenueAnalysisCard',
        meta: {
          requireAuth: true,
          title: '报表管理',
        },
        component: () =>
          import(
            '../views/Card/FinancialManagementCard/RevenueAnalysisCard.vue'
          ),
      },
      {
        path: '/FinanceSummarizeCard',
        name: 'FinanceSummarizeCard',
        meta: {
          requireAuth: true,
          title: '财务数据总结',
        },
        component: () =>
          import(
            '../views/Card/FinancialManagementCard/FinanceSummarizeCard.vue'
          ),
      },
      {
        path: '/Chartroom',
        name: 'Chartroom',
        meta: {
          requireAuth: true,
          title: '聊天室',
        },
        component: () =>
          import(/* webpackChunkName: "403" */ '../components/Chartroom.vue'),
      },
    ],
  },
  {
    path: '/History',
    name: 'History',
    component: () => import('../views/History.vue'),
  },
  {
    path: '/guide',
    name: 'guide',
    component: () => import('../views/Guide.vue'),
  },
  {
    path: '/guide',
    name: 'guide',
    component: () => import('../views/Guide.vue'),
  },
  // {
  //   path: '/Previewtopic',
  //   name: 'Previewtopic',
  //   component: () => import('../views/Previewtopic.vue'),
  // },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
